import axios from 'axios';

export const SEND_EMAIL_PASSWORD = '[Auth] SEND_EMAIL_PASSWORD';
export function sendEmailPassword() {
  return { type: SEND_EMAIL_PASSWORD };
}

export const SEND_EMAIL_PASSWORD_SUCCESS = '[Auth] SEND_EMAIL_PASSWORD_SUCCESS';
export function sendEmailPasswordSuccess(token) {
  return { type: SEND_EMAIL_PASSWORD_SUCCESS, token };
}

export const SEND_EMAIL_PASSWORD_FAILED = '[Auth] SEND_EMAIL_PASSWORD_FAILED';
export function sendEmailPasswordFailed(error) {
  return { type: SEND_EMAIL_PASSWORD_FAILED, error };
}

export const UPDATE_PASSWORD = '[Auth] UPDATE_PASSWORD';
export function updatePassword(data) {
  return { type: UPDATE_PASSWORD, data };
}

export const UPDATE_PASSWORD_FAILED = '[Auth] UPDATE_PASSWORD_FAILED';
export function updatePasswordFailed(error, token) {
  return { type: UPDATE_PASSWORD_FAILED, error, token };
}

export const UPDATE_PASSWORD_SUCCESS = '[Users] UPDATE_PASSWORD_SUCCESS';
export function updatePasswordSuccess(data) {
  return { type: UPDATE_PASSWORD_SUCCESS, data };
}

export function sendEmail({ email }) {
  return async function (dispatch) {
    dispatch(sendEmailPassword());
    try {
      const url = `${window.config.API_URL_USER}auth/reset-email?email=${email}`;
      const res = await axios.get(url, {
        headers: {
          // Authorization: 'Bearer'
        }
      });

      if (res.status === 201) {
        dispatch(sendEmailPasswordSuccess(res.data.data));
      } else {
        dispatch(sendEmailPasswordFailed(res.error));
      }
    } catch (error) {
      dispatch(sendEmailPasswordFailed(error));
    }
  };
}

export function resetPassword(clave, token) {
  return async function (dispatch) {
    dispatch(updatePassword());
    try {
      const url = `${window.config.API_URL_USER}auth/reset`;
      const res = await axios.put(
        url,
        { clave, token },
        {
          headers: {
            // Authorization: 'Bearer'
          }
        }
      );

      if (res.status === 201) {
        dispatch(updatePasswordSuccess(res.data.data));
      } else {
        dispatch(updatePasswordFailed(res.error));
      }
    } catch (error) {
      dispatch(updatePasswordFailed(error));
    }
  };
}
